<template>
<div>
  <footer class="footer py-4 d-flex flex-lg-column " id="kt_footer">
    <div class="container-xxl d-flex justify-content-between bd-highlight align-items-center">
      <div class="p-2 bd-highlight">
        <span class="text-muted fw-bold me-1">{{fullYear}}©          
          <a href="https://polisoft.uk" target="_blank" class="text-muted fs-7 fw-semibold text-hover-primary">
             {{ $t('polisoft_software_ltd') }} 
          </a>
        </span> 
      </div>
      <div class="p-2 bd-highlight">
        <Contents/>
      </div>
      <div class="p-2 bd-highlight">        
        <a href="https://creatorcube.uk" target="_blank" class="text-muted fs-7 fw-semibold text-hover-primary">
          CreatorCUBE v{{ cubeVersion }} CP
        </a>
      </div>
      <div class="p-2 bd-highlight" v-if="userData.company_name">
        <span class="badge badge-light align-items-right justify-content-end text-muted fs-7 fw-semibold">
          {{userData.company_name }} 
          <span v-if="userData.company_vkn !== null && userData.company_vkn !== '' && userData.company_vkn !== undefined">  
            ({{ userData.company_vkn }})
          </span> 
        </span> 
      </div>
      
      <div class="flex-grow-1 bd-highlight d-none">
        <!-- Idle for Screen Lock -->
        <Vidle v-if="this.userData.is_locked !== 1 && this.userData.is_lock_screen_active == 1 && userData.lock_screen_time > 0" @idle="onScreenLock" :wait="3" :duration="lockScreenTime" />
      </div>
      <div class="flex-grow-1 bd-highlight d-none">
        <!-- Idle for Logout -->
        <Vidle v-if="this.userData.is_automatic_logout_active == 1 && userData.automatic_logout_time > 0" @idle="forceSignOut" @remind="onremind" :reminders="[10]" :wait="3" :duration="automaticLogoutTime" />
      </div> 
    </div>
  </footer>
</div>
</template>  
<style>
</style>
<script>
import axios from "axios";
import Contents from "../Contents.vue";
export default {
  name: 'Home',
  components: {
    Contents
  },
  data() {
    return {
      userData: this.$getUser(),
      automaticLogoutTime: this.$getUser().automatic_logout_time ? this.$getUser().automatic_logout_time * 60 : 0,
      lockScreenTime: this.$getUser().lock_screen_time ? this.$getUser().lock_screen_time * 60 : 0,
      fullYear: new Date().getFullYear(),
      cubeVersion: null
    };
  },
  methods: {
    onremind() {
      let timerInterval;
      const inactiveMessage = this.$t('inactive_message', { 
        minutes: `<span class="fw-bolder">${this.userData.automatic_logout_time}</span>` 
      });
      const logoutMessage = this.$t('logout_warning');
      const dataLossMessage = this.$t('data_loss_warning', {
        stayLoggedIn: `<span class="fw-bolder">${this.$t('stay_logged_in')}</span>`
      });
      this.$swal.fire({
        title: this.$t('session_expiring_soon'),
        html: `${inactiveMessage} <b></b> ${logoutMessage} ${dataLossMessage}`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t('stay_logged_in'),
        allowOutsideClick: false,
        timer: 10000,
        timerProgressBar: true,
        didOpen: () => {
          const b = this.$swal.getHtmlContainer().querySelector('b');
          b.textContent = 10;
          timerInterval = setInterval(() => {
            b.textContent = (this.$swal.getTimerLeft() / 1000).toFixed(0)
          }, 1000)
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      });
    },
    forceSignOut() {
      this.$parent.isScreenLocked = false;
      this.$removeUser('user_' + this.$getUser().session_id);
      sessionStorage.clear();
      this.$router.push({ name: 'Logout', params: { m: this.userData.automatic_logout_time } });
    },
    onScreenLock() {
      this.userData.is_locked = 1;
      this.$parent.isScreenLocked = true;
    },
    getVersion() {
      axios.get('/api/Helper/GetVersion').then((response) => {
        this.cubeVersion = response.data;
      })
      .catch((error) => {
         console.error(error);
      });
    }
  },
  mounted() {
    this.emitter.on("changeScreenLockStatus", item => {
      this.userData.is_locked = item;
    });
  },
  created() {
    this.getVersion();
  }
}
</script>